'use client'
import React from 'react'
import Loader from './Loader'

interface Props {
  customClass?: string
  label: string
  disabled?: boolean
  onClick?: () => void
  isLoading?: boolean
}

const OutlinedButtonWithLoader = ({ customClass = '', label, onClick, isLoading = false, disabled = false }: Props) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`bg-white border-slateGray border font-sans text-center text-16 md:text-18 h-[3.5rem] w-[100%]
                        flex items-center text-slateGray justify-center rounded-lg ${customClass} ${
        disabled ? 'cursor-not-allowed' : 'cursor-pointer'
      }`}>
      <div className="flex-1" />
      <div>{label}</div>
      <div className="flex-1">
        <Loader isLoading={isLoading} style={{ marginLeft: '0.5rem', borderTopColor: '#2F8EE5' }} />
      </div>
    </button>
  )
}

export default OutlinedButtonWithLoader
